var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 10C15.833 11.3807 14.7138 12.5 13.333 12.5C11.9523 12.5 10.833 11.3807 10.833 10C10.833 8.61925 11.9523 7.5 13.333 7.5C14.7138 7.5 15.833 8.61925 15.833 10Z",
    stroke: "#0ACD95",
    strokeWidth: 1.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 5H6.6665C3.90508 5 1.6665 7.23857 1.6665 10C1.6665 12.7614 3.90508 15 6.6665 15H13.3332C16.0946 15 18.3332 12.7614 18.3332 10C18.3332 7.23857 16.0946 5 13.3332 5Z",
    stroke: "#0ACD95",
    strokeWidth: 1.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active-icon.3d7cb3eb1b5786b1416d90f2a8185456.svg";
export { ForwardRef as ReactComponent };